<template>
  <div class="card">
    <Form @submit="onSubmit" :validation-schema="schema">
      <div class="card-header">
        <h4 class="card-title">Value | Create</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <SelectInput
            :value="value.namespace"
            name="namespace"
            :options="namespaces"
            label="Namespace"
            placeholder="--- Select Namespace ---"
            success-message="Good!"
          />

          <TextInput
            :value="value.code"
            name="code"
            type="email"
            label="Code"
            placeholder="Code"
            success-message="Good!"
          />

          <NumberInput
            :value="value.year"
            name="year"
            type="number"
            label="Year"
            placeholder="Year"
            success-message="Good!"
          />

          <NumberInput
            :value="value.new_price"
            name="new_price"
            type="number"
            label="New Price"
            placeholder="New Price"
            success-message="Good!"
          />

          <NumberInput
            :value="value.trade_price"
            name="trade_price"
            type="number"
            label="Trade Price"
            placeholder="Trade Price"
            success-message="Good!"
          />

          <NumberInput
            :value="value.retail_price"
            name="retail_price"
            type="number"
            label="Retail Price"
            placeholder="Retail Price"
            success-message="Good!"
          />
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-xl-12">
            <div role="group" class="float-right btn-group">
              <button type="submit" class="btn btn-success btn-sm">Save</button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import * as Yup from "yup";
import { useRouter } from "vue-router";
import TextInput from "../../components/TextInput";
import NumberInput from "../../components/NumberInput";
import SelectInput from "../../components/SelectInput";
import { namespaceList } from "../../controllers/data-contoller";
import { createValue } from "../../controllers/value-contoller";

export default {
  name: "ValueCreate",
  components: {
    Form,
    TextInput,
    NumberInput,
    SelectInput,
  },
  async setup() {
    const router = useRouter();
    const value = {
      namespace: "",
      code: "",
      year: 2021,
      new_price: 0,
      retail_price: 0,
      trade_price: 0,
    };

    async function onSubmit(values) {
      try {
        await createValue(values);
        await router.push({ name: "ValueList" });
      } catch (e) {
        alert("something went wrong");
      }
    }

    const schema = Yup.object().shape({
      code: Yup.string().required(),
      namespace: Yup.string().required(),
      year: Yup.number().required(),
      new_price: Yup.number().required(),
      retail_price: Yup.number().required(),
      trade_price: Yup.number().required(),
    });

    return {
      onSubmit,
      schema,
      value,
    };
  },
  data: () => {
    return {
      namespaces: namespaceList,
    };
  },
};
</script>
